var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-container",
    [
      _c("div", { staticClass: "app-screen-config" }, [
        _c(
          "div",
          { staticClass: "app-screen-config-left" },
          [
            _c(
              "el-form",
              {
                ref: "form",
                attrs: {
                  model: _vm.form,
                  rules: _vm.rules,
                  "label-width": "100px",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "配置名称", prop: "name" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "600px" },
                      attrs: { placeholder: "配置名称" },
                      model: {
                        value: _vm.form.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "name", $$v)
                        },
                        expression: "form.name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "背景图", prop: "backgroundImage" } },
                  [
                    _c(
                      "el-upload",
                      {
                        staticClass: "avatar-uploader",
                        attrs: {
                          "before-upload": _vm.fileCheck,
                          "http-request": _vm.upload,
                          "show-file-list": false,
                        },
                      },
                      [
                        _vm.form.backgroundImage
                          ? _c("el-image", {
                              staticClass: "avatar",
                              attrs: {
                                src: _vm.form.backgroundImage,
                                fit: "scale-down",
                              },
                            })
                          : _c("i", {
                              staticClass: "el-icon-plus avatar-uploader-icon",
                            }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "备注", prop: "remark" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "600px" },
                      attrs: { placeholder: "备注", type: "textarea", rows: 3 },
                      model: {
                        value: _vm.form.remark,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "remark", $$v)
                        },
                        expression: "form.remark",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "行配置", prop: "rowData" } },
                  [
                    _c(
                      "el-button",
                      { attrs: { type: "primary" }, on: { click: _vm.addRow } },
                      [_vm._v("添加行")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "770px" },
                    attrs: {
                      "row-class-name": _vm.tableRowClassName,
                      data: _vm.tableData,
                      border: "",
                      "max-height": "440",
                      "span-method": _vm.objectSpanMethod,
                    },
                    on: {
                      "cell-mouse-enter": _vm.handleCellMouseEnter,
                      "cell-mouse-leave": _vm.handleCellMouseLeave,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "id",
                        label: "#",
                        width: "50",
                        align: "center",
                        "header-align": "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "componentHeight",
                        label: "行高",
                        width: "80",
                        align: "center",
                        "header-align": "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _vm._v(
                                "\n              " +
                                  _vm._s(row.componentHeight) +
                                  "px\n            "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "componentImage",
                        label: "组件图示",
                        width: "250",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "image-cell" },
                                [
                                  row.componentImage
                                    ? _c("el-image", {
                                        staticStyle: {
                                          width: "100%",
                                          height: "50px",
                                          display: "block",
                                          cursor: "pointer",
                                        },
                                        attrs: {
                                          src: row.componentImage,
                                          fit: "scale-down",
                                          "preview-src-list": [
                                            row.componentImage,
                                          ],
                                        },
                                      })
                                    : _c("span", [_vm._v("暂无图片")]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "responseType",
                        label: "响应类型",
                        width: "100",
                        align: "center",
                        "header-align": "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.getComponentTypeLabel(row.responseType)
                                  ) +
                                  "\n            "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "componentName",
                        label: "名称",
                        width: "100",
                        align: "center",
                        "header-align": "center",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "componentExt",
                        label: "扩展字段",
                        width: "120",
                        align: "center",
                        "header-align": "center",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "componentWidth",
                        label: "组件宽度",
                        width: "80",
                        align: "center",
                        "header-align": "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _vm._v(
                                "\n              " +
                                  _vm._s(row.componentWidth) +
                                  "px\n            "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "sort",
                        label: "排序",
                        width: "100",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleUp(row)
                                    },
                                  },
                                },
                                [_vm._v("上移")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDown(row)
                                    },
                                  },
                                },
                                [_vm._v("下移")]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "handle", label: "操作", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleEdit(row)
                                    },
                                  },
                                },
                                [_vm._v("编辑")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleRemove(row)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-top": "20px" },
                    attrs: { label: "状态", prop: "status" },
                  },
                  [
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.form.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "status", $$v)
                          },
                          expression: "form.status",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: 1 } }, [
                          _vm._v("生效"),
                        ]),
                        _c("el-radio", { attrs: { label: 0 } }, [
                          _vm._v("失效"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "app-screen-config-right" }, [
          _c(
            "div",
            { staticClass: "demonstration-area-container" },
            [
              _vm.tableData.length > 0
                ? _vm._l(_vm.form.rowData, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.id,
                        staticClass: "demonstration-area-row",
                        style: { height: item.componentHeight + "px" },
                      },
                      _vm._l(item.rowComponent, function (rowItem) {
                        return _c(
                          "div",
                          {
                            key: rowItem.id,
                            staticClass: "demonstration-area-row-item",
                            style: {
                              width: rowItem.componentWidth + "px",
                              height: item.componentHeight + "px",
                            },
                          },
                          [
                            _c("el-image", {
                              staticStyle: { width: "100%", height: "100%" },
                              attrs: {
                                src: rowItem.componentImage,
                                fit: "fill",
                              },
                            }),
                          ],
                          1
                        )
                      }),
                      0
                    )
                  })
                : [
                    _c(
                      "div",
                      { staticClass: "demonstration-area-row-no-data" },
                      [_vm._v("暂无数据")]
                    ),
                  ],
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "bottom-button" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$emit("back")
                    },
                  },
                },
                [_vm._v("返回")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("EditRowDialog", {
        ref: "editRowDialog",
        attrs: { componentTypeList: _vm.componentTypeList },
        on: {
          saveRowComponent: _vm.saveRowComponent,
          addRowComponent: _vm.addRowComponent,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }